module.exports = __webpack_public_path__ + "static/media/icomoon.f1f8eaa6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/icomoon.woff?l4wga5
// module id = 1481
// module chunks = 0